var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ai-document-content" },
    [
      _vm.hasPendingInvoices
        ? _c(
            "AIContentList",
            {
              attrs: {
                hasMargin: _vm.hasPendingQuotes || _vm.hasOngoingOpportunities
              }
            },
            [
              _c("ul", [
                _c("li", [
                  _c(
                    "span",
                    { staticClass: "typographies-paragraph-medium-semibold" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$t.__(
                              "overview.tabs.TabSummary.paymentContent.pending_invoices"
                            )
                          ) +
                          "\n                "
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.$t.__(
                          "overview.tabs.TabSummary.paymentContent.due_invoices"
                        )
                      ) +
                      " :\n                " +
                      _vm._s(
                        _vm._f("numberformatCurrency")(
                          _vm.dueInvoicesTotalAmount
                        )
                      ) +
                      "\n            "
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.$t.__(
                          "overview.tabs.TabSummary.paymentContent.late_invoices"
                        )
                      ) +
                      " :\n                " +
                      _vm._s(
                        _vm._f("numberformatCurrency")(
                          _vm.lateInvoicesTotalAmount
                        )
                      ) +
                      "\n            "
                  )
                ])
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.hasPendingQuotes
        ? _c(
            "AIContentList",
            { attrs: { hasMargin: _vm.hasOngoingOpportunities } },
            [
              _c(
                "h4",
                { staticClass: "typographies-paragraph-medium-semibold" },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.$t.__(
                          "overview.tabs.TabSummary.paymentContent.pending_quotes"
                        )
                      ) +
                      "\n        "
                  )
                ]
              ),
              _vm._v(" "),
              _c("ul", [
                _c("li", [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.$t.__(
                          "overview.tabs.TabSummary.paymentContent.sent"
                        )
                      ) +
                      " :\n                " +
                      _vm._s(
                        _vm._f("numberformatCurrency")(
                          _vm.sentQuotesTotalAmount
                        )
                      ) +
                      "\n            "
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.$t.__(
                          "overview.tabs.TabSummary.paymentContent.read"
                        )
                      ) +
                      " :\n                " +
                      _vm._s(
                        _vm._f("numberformatCurrency")(
                          _vm.readQuotesTotalAmount
                        )
                      ) +
                      "\n            "
                  )
                ])
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.hasOngoingOpportunities
        ? _c("AIContentList", { attrs: { hasMargin: false } }, [
            _c(
              "h4",
              { staticClass: "typographies-paragraph-medium-semibold" },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.$t.__(
                        "overview.tabs.TabSummary.paymentContent.on_going_opportunities"
                      )
                    ) +
                    "\n        "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "ul",
              _vm._l(_vm.onGoingOpportunities, function(opportunity) {
                return _c("li", { key: opportunity.id }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(opportunity.name) +
                      " : " +
                      _vm._s(
                        _vm._f("numberformatCurrency")(opportunity.potential)
                      ) +
                      " (" +
                      _vm._s(opportunity.funnel_step) +
                      ")\n            "
                  )
                ])
              }),
              0
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.hasNoData ? _c("NoInvoicingData") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }